import { DottedSeparatorProps } from "@/types/modules/post/components";
import React from "react";

export const DottedSeparator: React.FC<DottedSeparatorProps> = ({ color = "dark" }) => {
  return (
    <div
      className={`h-px w-full bg-[length:3px_1px] bg-bottom bg-repeat-x ${
        color === "dark" && "bg-[linear-gradient(to_right,#0d0603_33%,rgba(255,255,255,0)_0%)] dark:bg-white"
      } ${color === "gray" && "bg-[linear-gradient(to_right,#E6E4E3_33%,rgba(255,255,255,0)_0%)]"} ${
        color === "white" && "bg-[linear-gradient(to_right,#ffffff33_33%,rgba(255,255,255,0)_0%)]"
      }`}
    />
  );
};
